import { useCallback, useState, forwardRef } from "react";

function DevelopmentOverview() {
  return (
    <div className={`flex justify-center items-stretch flex-col grow-0 shrink-0 basis-auto mt-[45px]`}>
      <p className={`[font-family:Inter] text-[25px] font-bold text-[#1e1e1e] grow-0 shrink-0 basis-auto m-0 p-0`}>Partnered Development</p>
      <p className={`[font-family:Inter] text-xl font-normal text-left leading-[30px] text-[#1e1e1e] grow-0 shrink-0 basis-auto mt-5 m-0 p-0`}>
        Collaborative creation of tailored platforms, ensuring they align precisely with client needs and industry standards.
      </p>
    </div>
  );
}

export default DevelopmentOverview;
